import { render, staticRenderFns } from "./PostalSeparateInputs.be.vue?vue&type=template&id=8dc8c2b6"
import script from "./PostalSeparateInputs.be.vue?vue&type=script&lang=js"
export * from "./PostalSeparateInputs.be.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports